import React from "react";

const DEAL_STAGES = [
  { name: "Site Visit", activeStages: 1 },
  { name: "After Site Visit Follow Up", activeStages: 2 },
  { name: "Sitting", activeStages: 3 },
  { name: "After Sitting Follow Up", activeStages: 4 },
  { name: "Plot Booked", activeStages: 5 },
  { name: "Advance Amount Update", activeStages: 6 },
  { name: "Registration InProgress", activeStages: 7 },
  { name: "Fully Registered", activeStages: 8 },
  { name: "Deal Lost Before Booking", activeStages: 9, status: "lost" },
  { name: "Deal Lost After Booking", activeStages: 10, status: "lost" },
];

const TileProgress = ({ activeCount, isLost }) => {
  return (
    <div className={`tile-progress ${isLost ? "lost" : ""}`}>
      {[...Array(10)].map((_, index) => (
        <div key={index} className={`tiles ${index < activeCount ? (isLost ? "lost" : "active") : ""}`}>
          <span>
            <div className="triangle-right-inside"></div>
          </span>
          <div className="triangle-right"></div>
        </div>
      ))}
    </div>
  );
};

const DealProgress = ({ dealStageSelected }) => {
  const selectedStage = DEAL_STAGES.find((stage) => stage.name === dealStageSelected);

  return selectedStage ? (
    <TileProgress activeCount={selectedStage.activeStages} isLost={selectedStage.status === "lost"} />
  ) : null;
};

export default DealProgress;
